import React from 'react';
import Logo from '../Header/logo_new.svg';
import './NotFound.css';
import leftHand from './left_hand.png';
import rightHand from './right_hand.png';
import { routesAction } from '../../shared/helpers';
import { connect } from 'react-redux';

const NotFound = props => (
  <div className="page not-found-page">
    {!props.isLogin && (
      <div className="logo">
        <a href="https://dreamitreel.com" className="navbar-brand">
          <img alt="Dream it Reel Logo" src={Logo} />
        </a>
      </div>
    )}
    <div className="not-found-container">
      <img className="left-hand" src={leftHand} />
      <div className="not-found-block">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>Sorry, the page you are looking for doesn’t exist</p>
        <button onClick={() => props.history.push(routesAction.default())} className="btn form-submit">
          Home page
        </button>
      </div>
      <img className="right-hand" src={rightHand} />
    </div>
  </div>
);

const mapStateToProps = state => ({
  isLogin: state.authentication.isLogin,
});

export default connect(
  mapStateToProps,
  null,
)(NotFound);



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js